import ValidateForm, { validator } from '@resources/js/components/ValidateForm'
import { generateBcomSearchUrl } from '@resources/js/helpers/generateBcomUrl'
import sendClickunderStats from '@resources/js/components/clickunderStats'


export default class BcomSearchForm extends ValidateForm {
    constructor(triggerSelector) {
        super(triggerSelector)

        this.rules = {
            ss: validator.required
        }

        this.form.addEventListener('submit', this.submit.bind(this))
    }

    submit(e) {
        e.preventDefault()

        const isValid = this.validate()
        if (!isValid)
            return

        const type = "searchform"
        const formData = new FormData(this.form);
        const formDataObject = Object.fromEntries(formData.entries())
        const partnerUrl = generateBcomSearchUrl(formDataObject, { type })

        sendClickunderStats({type, partnerUrl})

        window.open(partnerUrl)

        this.emit('after_submit')

        this.touch = false
        this.form.reset()
    }
}
